/**
 * axios共通設定
 * セッションCookieを送るため withCredentials: true を設定
 *
 * baseURLは .env（VUE_APP_API_BASE）で切り替え可能。
 * 未設定時は開発機でのローカル動作用に localhost:4000 を使用。
 */
import axios from 'axios';

const api = axios.create({
  baseURL: process.env.VUE_APP_API_BASE ?? '',
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

// Management writes require a session-bound CSRF token, including after reload.
api.interceptors.request.use(async (config) => {
  const method = (config.method || 'get').toLowerCase();
  const url = config.url || '';
  if (
    !['get', 'head', 'options'].includes(method) &&
    !url.startsWith('/api/auth/') &&
    url !== '/api/admin/login'
  ) {
    const { data } = await api.get('/api/admin/me');
    config.headers['X-CSRF-Token'] = data.csrfToken;
  }
  return config;
});

export default api;
